export enum IotMessageType {
  DATA = 'DATA',
  CONNECTION_LOG = 'CONNECTION_LOG',
  CONNECTION_TEST = 'CONNECTION_TEST',
}
